import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { CancelButton } from 'shared/mui/Buttons';
import { CardActionsButtons, CardHeader } from 'shared/mui/Card';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';
import { Dialog } from 'shared/mui/Dialogs';
import { CloseIconButton } from 'shared/mui/IconButtons';
import { OrderAdjustments } from 'types/embedded/orderAdjustments';

type Props = {
  open: boolean;
  onClose: VoidFunction;
  record: OrderAdjustments | undefined;
};

export const OrderAdjustmentsReportCommentDialog: React.FC<Props> = ({ open, record, onClose }) => {
  const translate = useTypedTranslate();

  return (
    <Dialog maxWidth="sm" onClose={onClose} open={open}>
      <CardHeader
        appendActions={<CloseIconButton key="close-button" onClose={onClose} />}
        sx={{ width: '600px' }}
        title={translate('app.orderAdjustmentsReport.commentDialogTitle', {
          id: record?.originId,
        })}
        titleSize="smallBold"
      />
      <CardContent>{record?.comment}</CardContent>
      <CardActionsButtons
        rightActionsSlot={[
          <CancelButton
            key="cancel-button"
            label={translate('app.orderAdjustmentsReport.returnToList')}
            onClick={onClose}
            variant="contained"
          />,
        ]}
      />
    </Dialog>
  );
};
